import { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Form,
  Header,
  Input,
  TextArea,
} from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EPICS_PATH_CONTINUE } from 'volto-epics-addon/constants';
import { TASK_LIVE_INFO_PROMPT } from 'volto-m4-theme-addon/constants';
import { completeTask, useTask } from 'volto-epics-addon/helpers';
import { useIntl, defineMessages } from 'react-intl';
import DatetimeWidget from '@plone/volto/components/manage/Widgets/DatetimeWidget';

const messages = defineMessages({
  liveInfo: {
    id: 'liveInfo',
    defaultMessage: 'Live info',
  },
  liveTitle: {
    id: 'liveTitle',
    defaultMessage: 'Title',
  },
  liveDescription: {
    id: 'liveDescription',
    defaultMessage: 'Description',
  },
  liveUrl: {
    id: 'liveUrl',
    defaultMessage: 'Live URL',
  },
  liveStartTime: {
    id: 'liveStartTime',
    defaultMessage: 'Live starts',
  },
  liveEndTime: {
    id: 'liveEndTime',
    defaultMessage: 'Live ends',
  },
  submit: {
    id: 'submit',
    defaultMessage: 'Submit',
  },
  mustSetTitle: {
    id: 'mustSetTitle',
    defaultMessage: 'You must set a title.',
  },
  mustSetDescription: {
    id: 'mustSetDescription',
    defaultMessage: 'You must set a description.',
  },
  mustLoginFirst: {
    id: 'mustLoginFirst',
    defaultMessage: 'You must log in first.',
  },
});

const Page = () => {
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [liveUrl, setLiveUrl] = useState('');
  const [liveStart, setLiveStart] = useState('');
  const [liveEnd, setLiveEnd] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const task = useTask(TASK_LIVE_INFO_PROMPT);
  const token = useSelector((state) => state.userSession.token);
  const intl = useIntl();

  useEffect(() => {
    setIsAuthenticated(!!token);
    setIsVisible(true);
  }, [token]);

  useEffect(() => {
    if (task?.completed === true) {
      history.push(EPICS_PATH_CONTINUE);
    }
  }, [task, history]);

  const onSubmit = async (ev) => {
    if (!token) return;

    ev.nativeEvent.preventDefault();

    try {
      if (!title) {
        // eslint-disable-next-line no-alert
        alert(intl.formatMessage(messages.mustSetTitle));
        return;
      }
      if (!description) {
        // eslint-disable-next-line no-alert
        alert(intl.formatMessage(messages.mustSetDescription));
        return;
      }
      completeTask(TASK_LIVE_INFO_PROMPT, {
        title: title,
        description: description,
        liveUrl: liveUrl,
        liveStart: liveStart ? liveStart : '',
        liveEnd: liveEnd ? liveEnd : '',
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  return isVisible ? (
    isAuthenticated ? (
      <Container className="basicinfo-prompt-container">
        <Header>{intl.formatMessage(messages.liveInfo)}</Header>
        <Form onSubmit={onSubmit}>
          <Form.Field
            onChange={(e) => setTitle(e.target.value)}
            label={intl.formatMessage(messages.liveTitle)}
            control={Input}
            required
          ></Form.Field>
          <Form.Field
            onChange={(e) => setDescription(e.target.value)}
            label={intl.formatMessage(messages.liveDescription)}
            control={TextArea}
            required
          ></Form.Field>
          <Form.Field
            onChange={(e) => setLiveUrl(e.target.value)}
            label={intl.formatMessage(messages.liveUrl)}
            control={Input}
          ></Form.Field>
          <div className="live-date-inputs">
            <Form.Field
              label={intl.formatMessage(messages.liveStartTime)}
              title={intl.formatMessage(messages.liveStartTime)}
              wrapped={false}
              control={DatetimeWidget}
              value={liveStart}
              onChange={(id, value) => {
                setLiveStart(value);
              }}
              id="live-start"
            ></Form.Field>
            <Form.Field
              label={intl.formatMessage(messages.liveEndTime)}
              title={intl.formatMessage(messages.liveEndTime)}
              wrapped={false}
              control={DatetimeWidget}
              value={liveEnd}
              onChange={(id, value) => {
                setLiveEnd(value);
              }}
              id="live-end"
            ></Form.Field>
          </div>
          <Button style={{ marginTop: '1em' }} floated="right" type="submit">
            {intl.formatMessage(messages.submit)}
          </Button>
        </Form>
      </Container>
    ) : (
      <Container className="basicinfo-prompt-container">
        <Header className="ui header">
          {intl.formatMessage(messages.mustLoginFirst)}
        </Header>
      </Container>
    )
  ) : (
    <Container className="basicinfo-prompt-container"></Container>
  );
};

export default Page;
